import { TabItemSource } from '@/types';

export const validateTab = (tabDataSource: TabItemSource) => {
  const isMainError = !!tabDataSource?.errorFields?.length;
  if (isMainError) {
    return isMainError;
  }
  // 检查动态扩展的子检查项
  return tabDataSource?.subItems?.some?.(({ errorFields }) => !!errorFields?.length);
};

export const validateChildTask = (tabsDataSource: TabItemSource[]) => {
  return tabsDataSource?.some?.(tab => validateTab(tab));
};
